import { defineStore } from "pinia";
import Dagger from "@/themes/Dagger";
import Raze from "@/themes/Raze";
import { APP_CONFIG } from "@/config/app-config";

export const themes = [
  {
    name: "dagger",
    component: Dagger,
  },
  {
    name: "raze",
    component: Raze,
  },
] as const;

export type Themes = (typeof themes)[number];

interface ThemeState {
  value: Themes["name"];
}

export const getTheme = (search?: Themes["name"]) => {
  const theme = search;
  return (
    themes.filter((item, key) => {
      return item.name === theme;
    })[0] || themes[0]
  );
};

export const useThemeStore = defineStore("theme", {
  state: (): ThemeState => ({
    value: getTheme(APP_CONFIG.theme as Themes["name"]).name,
  }),
  getters: {
    theme(state) {
      return state.value;
    },
  },
  actions: {
    setTheme(_theme: Themes["name"]) {
      this.value = getTheme(APP_CONFIG.theme as Themes["name"]).name;
    },
  },
});
